import { useState } from "react";
import { Alert } from "antd";
import { useEditorState } from "@/store";

const AlertArea = () => {
  const { metadata, sessionUser: user, language } = useEditorState();
  const [alertHover, setAlertHover] = useState<boolean>(false);
  return (
    <>
      {metadata?.is_preview && (
        <div>
          <Alert
            rootClassName="mb-2 rounded-lg block"
            onMouseEnter={() => setAlertHover(true)}
            onMouseLeave={() => setAlertHover(false)}
            message={
              language === "en" ? (
                <span className="text-sm p-0 m-0">
                  {!alertHover
                    ? "You are currently in preview mode, show more information."
                    : "You are currently in preview mode. You can only vies and edit the student's course page. But you can't save & publish the project"}
                </span>
              ) : (
                <span className="text-sm p-0 m-0">
                  {!alertHover
                    ? "Şu anda önizleme modundasınız, daha fazla bilgi göster."
                    : "Şu anda önizleme modundasınız. Öğrencinin ders ekranını yalnızca görüntüleyebilir ve düzenleyebilirsiniz. Ancak ders ekranında yaptığınız değişiklikleri kaydedemez ve yayınlayamazsınız."}
                </span>
              )
            }
            banner
            closable
            className="h-8"
          />
        </div>
      )}
      {!metadata?.isProjectOwner && (
        <div>
          <Alert
            rootClassName="mb-2 rounded-lg block"
            onMouseEnter={() => setAlertHover(true)}
            onMouseLeave={() => setAlertHover(false)}
            message={
              language === "en" ? (
                <span className="text-sm p-0 m-0">
                  {!alertHover
                    ? `You are currently viewing the project shared by ${user?.username}.`
                    : `You are currently viewing the project shared by ${user?.username}. | The changes you make will be visible to the student.`}
                </span>
              ) : (
                <span className="text-sm p-0 m-0">
                  {!alertHover
                    ? `Şu anda ${user?.username} tarafından paylaşılan projeyi görüntülüyorsunuz.`
                    : `Şu anda ${user?.username} tarafından paylaşılan projeyi görüntülüyorsunuz. | Yaptığınız değişikler öğrenci tarafından görüntülenebilecektir.`}
                </span>
              )
            }
            banner
            closable
            className="h-8"
          />
        </div>
      )}
    </>
  );
};

export default AlertArea;
